import {
  Pill,
  Syringe,
  Utensils,
  CookingPot,
  Shirt,
  Smartphone,
  Sparkles,
  SprayCan,
  ShoppingBag,
  Package,
  AlertTriangle,
} from "lucide-react";

const RULES = [
  { test: /pharm|medic|drug|tablet|syrup|injection|paracet|amox|ceftri|gentamic|vitamin|capsule/i, Icon: Pill },
  { test: /syring|inject|vaccine/i, Icon: Syringe },
  { test: /food|rice|beans|flour|snack|bread|meal|cook|garri|yam|oil|spice/i, Icon: Utensils },
  { test: /restaurant|cater|kitchen/i, Icon: CookingPot },
  { test: /fashion|cloth|shirt|dress|fabric|wear|shoe|sneaker/i, Icon: Shirt },
  { test: /phone|electronic|laptop|computer|charger|gadget|tv|speaker/i, Icon: Smartphone },
  { test: /beauty|cosmetic|cream|lotion|perfume|makeup|soap/i, Icon: Sparkles },
  { test: /spray|detergent|clean/i, Icon: SprayCan },
];

export function getProductIconComponent(name, category) {
  const text = `${name || ""} ${category || ""}`;
  for (const rule of RULES) {
    if (rule.test.test(text)) return rule.Icon;
  }
  return ShoppingBag;
}

export function ProductIcon({ name, category, size = 20, className = "", lowStock = false }) {
  const Icon = lowStock ? AlertTriangle : getProductIconComponent(name, category);
  const color = lowStock ? "var(--color-error)" : "var(--color-primary)";
  return (
    <Icon
      size={size}
      strokeWidth={1.75}
      color={color}
      className={`flex-shrink-0 ${className}`.trim()}
      aria-hidden
    />
  );
}

export { Package as DefaultProductIcon };
